export default __webpack_public_path__ + "static/milestone-screen-5e379e054fc5dfc39628db1d54ff5762.webp";